import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineMarkerColorsConstantType,
    TimelineMarkerDynamicStyleType,
    TimelineMarkerColors
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    STATE_COLOR_KEYS
} from "../../../../helpers/theme/state";

export const getTimelineMarkerColors = ({
    colors,
    type
}: TimelineMarkerColorsConstantType): TimelineMarkerColors => {
    if(type === "neutral") {
        return {
            backgroundColor: colors.content.container.subtle,
            dotColor: colors.content.icon.low,
            iconColor: colors.content.icon.mid
        };
    }

    return {
        backgroundColor: colors.system.low[STATE_COLOR_KEYS[type]],
        dotColor: colors.content.icon[type],
        iconColor: colors.content.icon[type]
    };
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    }
});

export const useStyles = ({
    isFilled,
    measures,
    radiuses,
    borders,
    colors
}: TimelineMarkerDynamicStyleType) => {
    const styles = {
        dot: {
            backgroundColor: colors.dotColor,
            height: borders.indicator * 2,
            width: borders.indicator * 2,
            borderRadius: radiuses.full
        } as Mutable<ViewStyle>,
        container: {
            borderRadius: radiuses.full,
            height: measures.markerSize,
            width: measures.markerSize
        } as Mutable<ViewStyle>
    };

    if(isFilled) {
        styles.container.backgroundColor = colors.backgroundColor;
    }

    return styles;
};
export default stylesheet;
